<template>
  <div
    class="headerIcon"
  >
    <div
      class="innerIcon"
      :class="{active}"
    >
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.75 14.75H0.75" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M0.75 6.75C0.75 4.54086 2.54086 2.75 4.75 2.75H16.75C18.9591 2.75 20.75 4.54086 20.75 6.75V16.75C20.75 18.9591 18.9591 20.75 16.75 20.75H4.75C2.54086 20.75 0.75 18.9591 0.75 16.75V6.75Z" :stroke="color" stroke-width="1.5"/>
        <path d="M6.75 0.75V4.25" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M14.75 0.75V4.25" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <div
        v-if="messages"
        class="messages"
      >
        {{ messages }}
      </div>
    </div>
  </div>
</template>

<script setup>

import {computed} from "vue";
import store from "@/store/store.js";

const messages = computed(() => {
  const count = store.state.user?.profile?.unchecked_interest_count + store.state.user?.profile?.unchecked_match_count
  if (count) {
    const num = Number(count)
    if (num > 99) {
      return `99+`
    }
    return num
  }
  return null
})

const props = defineProps({
  color: {
    type: String,
    default: '#ffffff' // #8B8B8B
  },
  active: {
    type: Boolean,
    default: false,
  },
})

</script>

<style lang="scss" scoped>
.headerIcon {
  width: 24px;
  height: 24px;
  position: relative;
}

.innerIcon {
  position: absolute;
  background: rgba(0, 0, 0, 0);
  width: 48px;
  height: 48px;
  left: -12px;
  top: -12px;
  padding: 10px;
  border: 2px solid rgba(231, 94, 94, 0);
  border-radius: 12px;
  box-shadow: 0 0 16px 0 rgba(231, 94, 94, 0);
  transition: all 1s linear;

  &.active {
    background: var(--app-accent-light-color);
    width: 48px;
    height: 48px;
    left: -12px;
    top: -24px;
    padding: 10px;
    border: 2px solid rgba(231, 94, 94, 0.24);
    border-radius: 12px;
    box-shadow: 0 0 8px 0 rgba(231, 94, 94, 0.3);
  }
}

.messages {
  position: absolute;
  background: var(--text-error-color);
  height: 15px;
  min-width: 15px;
  top: 5px;
  right: 5px;
  padding: 1px 4px;
  border-radius: 15px;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
  color: var(--text-primary-color);
}

</style>
